import api from './connectionProxy'

export const getRatings = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '', filter = '' } = params

  return api.http.get('/ratings/', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term,
      filter
    }
  })
}

export const getContentRatings = (params = {}) => {
  const { ratingId, page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get(`/ratings/${ratingId}/details`, {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getRating = id => {
  return api.http.get(`/ratings/${id}`)
}

export const editRating = (data, _id) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return api.http.put(`/ratings/${_id}`, data, config)
}

export const getSelectStatus = (term, callback) => {
  const options = [
    { value: 'Nova', label: 'Nova' },
    { value: 'Em revisão', label: 'Em revisão' },
    { value: 'Fechada', label: 'Fechada' }
  ]
  callback(null, {
    options,
    complete: true
  })
}



// WEBPACK FOOTER //
// ./src/api/ratings.js